import { render, staticRenderFns } from "./VLandingContainer.vue?vue&type=template&id=00fa8037&scoped=true"
import script from "./VLandingContainer.vue?vue&type=script&lang=js"
export * from "./VLandingContainer.vue?vue&type=script&lang=js"
import style0 from "./VLandingContainer.vue?vue&type=style&index=0&id=00fa8037&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fa8037",
  null
  
)

export default component.exports